import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "../../services/authService";

// Async thunks
export const loginUser = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      console.log("🔐 [AUTH SLICE] Login thunk started");
      const response = await authService.login(credentials);
      console.log("🔐 [AUTH SLICE] Login service response:", {
        hasToken: !!response?.token,
        hasRefreshToken: !!response?.refreshToken,
        hasUser: !!response?.user,
      });
      
      // Store tokens - authService.login already stores them, but ensure they're stored here too
      if (response?.token) {
        localStorage.setItem("authToken", response.token);
        console.log("💾 [AUTH SLICE] AuthToken stored in Redux thunk");
      }
      
      // CRITICAL: Always store refreshToken if it exists
      if (response?.refreshToken) {
        localStorage.setItem("refreshToken", response.refreshToken);
        console.log("💾 [AUTH SLICE] RefreshToken stored in Redux thunk");
      } else {
        console.error("❌ [AUTH SLICE] WARNING: No refreshToken in response!");
      }
      
      if (response?.user) {
        localStorage.setItem("user", JSON.stringify(response.user));
        console.log("💾 [AUTH SLICE] User data stored");
      }
      
      // Final verification
      const finalRefreshToken = localStorage.getItem("refreshToken");
      console.log("✅ [AUTH SLICE] Final refreshToken check:", {
        exists: !!finalRefreshToken,
        length: finalRefreshToken?.length || 0,
      });
      
      return response;
    } catch (error) {
      console.error("❌ [AUTH SLICE] Login failed:", error);
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

export const registerUser = createAsyncThunk(
  "auth/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authService.register(userData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Registration failed"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("authToken") || null,
    isLoading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      authService.logout();
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Register
      .addCase(registerUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
